import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "@fontsource/poppins";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import GetAQuote from "./pages/GetAQuote";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Careers from "./pages/Careers";
import Resource from "./pages/Resource";
import Blog from "./pages/Blog";
import Partnerwithus from "./pages/Partnerwithus";
import BlogPost from "./pages/BlogPost";
import Error404 from "./pages/Error404";
import Loader from "./components/Loader";
import Ebooks from "./pages/Ebooks";
import Sales from "./pages/Sales";
import Freetools from "./pages/Freetools";
import Marketplace from "./pages/Marketplace";
import Products from "./pages/Products";
import Timeline from "./pages/Timeline";
import RefundPolicy from "./pages/Refundpolicy";
import Outsourcing from "./pages/Outsourcing";
import Packages from "./pages/Packages";
import Reviews from "./pages/Reviews";
import Reviews2 from "./pages/Reviews2";
import Business from "./pages/Business";
import Education from "./pages/Education";
import Healthcare from "./pages/Healthcare";
import Professional from "./pages/Professional";
import Commerce from "./pages/Commerce";
import Finance from "./pages/Finance";
import BecomeAPartner from "./pages/BecomeAPartner";
import GetACall from "./pages/GetACall";
import Cosection1 from "./components/Cosection1";
import CareersFaqs from "./pages/CareersFaqs";
import OutsourcingFaqs from "./pages/OutsourcingFaqs";
import OutsourceRequest from "./pages/OutsourceRequest";

AOS.init({ duration: 1000 });

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

const App = () => {
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [showCallModal, setShowCallModal] = useState(false);
  const [showOutsourceModal, setShowOutsourceModal] = useState(false);

  // Protection against developer tools and copying
  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Disable keyboard shortcuts for dev tools
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key === "I") ||
        (e.ctrlKey && e.shiftKey && e.key === "J") ||
        (e.ctrlKey && e.key === "U") ||
        (e.ctrlKey && e.key === "u") ||
        (e.metaKey && e.altKey && e.key === "I") // Mac shortcut
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Prevent text selection
    const handleSelectStart = (e) => {
      e.preventDefault();
    };

    // Disable clipboard manipulation
    const handleCopy = (e) => {
      e.preventDefault();
    };

    // Disable image dragging
    const disableImageDrag = () => {
      const images = document.querySelectorAll('img');
      images.forEach(img => {
        img.setAttribute('draggable', 'false');
      });
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('selectstart', handleSelectStart);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('cut', handleCopy);
    disableImageDrag();

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('selectstart', handleSelectStart);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('cut', handleCopy);
    };
  }, []);

  // Handle route changes to close modal
  useEffect(() => {
    const handleRouteChange = () => {
      setShowQuoteModal(false);
      setShowCallModal(false);
    };
    window.addEventListener("popstate", handleRouteChange);
    return () => window.removeEventListener("popstate", handleRouteChange);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {/* Global CSS to prevent text selection and copying */}
      <style>
        {`
          * {
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
          }
          
          img {
            pointer-events: none;
            -webkit-user-drag: none;
            user-drag: none;
          }
          
          /* Allow selection in input fields and textareas */
          input, textarea {
            -webkit-user-select: text !important;
            -moz-user-select: text !important;
            -ms-user-select: text !important;
            user-select: text !important;
          }
        `}
      </style>
      
      <CssBaseline />
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <Home
                showQuoteModal={showQuoteModal}
                setShowQuoteModal={setShowQuoteModal}
              />
            }
          />
          <Route path="/outsourcingfaqs" element={<OutsourcingFaqs />} />
          <Route path="/careersfaqs" element={<CareersFaqs />} />
          <Route path="/getacall" element={<GetACall />} />
          <Route path="/cosection1" element={<Cosection1 />} />
          <Route
            path="/services"
            element={
              <Services
                showQuoteModal={showQuoteModal}
                setShowQuoteModal={setShowQuoteModal}
              />
            }
          />
          <Route
            path="/become_a_partner"
            element={
              <BecomeAPartner
                showCallModal={showCallModal}
                setShowCallModal={setShowCallModal}
              />
            }
          />
          <Route path="/finance" element={<Finance />} />
          <Route path="/commerce" element={<Commerce />} />
          <Route path="/professional" element={<Professional />} />
          <Route path="/business" element={<Business />} />
          <Route path="/education" element={<Education />} />
          <Route path="/healthcare" element={<Healthcare />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/reviews2" element={<Reviews2 />} />
          <Route
            path="/about"
            element={
              <About
                showQuoteModal={showQuoteModal}
                setShowQuoteModal={setShowQuoteModal}
              />
            }
          />
          <Route path="/getaquote" element={<GetAQuote />} />
          <Route path="/outsourcerequest" element={<OutsourceRequest />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refundpolicy" element={<RefundPolicy />} />
          <Route path="/careers" element={<Careers />} />
          <Route
            path="/resource"
            element={
              <Resource
                showQuoteModal={showQuoteModal}
                setShowQuoteModal={setShowQuoteModal}
              />
            }
          />
          <Route path="/blog" element={<Blog />} />
          <Route
            path="/outsourcing"
            element={
              <Outsourcing
                showOutsourceModal={showOutsourceModal}
                setShowOutsourceModal={setShowOutsourceModal}
              />
            }
          />
          <Route path="/loader" element={<Loader />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/packages" element={<Packages />} />
          <Route
            path="/products"
            element={
              <Products
                showQuoteModal={showQuoteModal}
                setShowQuoteModal={setShowQuoteModal}
              />
            }
          />
          <Route path="/timeline" element={<Timeline />} />
          <Route path="/ebooks" element={<Ebooks />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/freetools" element={<Freetools />} />
          <Route path="/partnerwithus" element={<Partnerwithus />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Router>
      <GetAQuote showModal={showQuoteModal} setShowModal={setShowQuoteModal} />
      <GetACall showModal={showCallModal} setShowModal={setShowCallModal} />
      <OutsourceRequest
        showModal={showOutsourceModal}
        setShowModal={setShowOutsourceModal}
      />
    </ThemeProvider>
  );
};

export default App;